// c:\git\Matwins\Matwins.UI.FrontOffice\src\app\components\auth-callback\auth-callback.component.ts
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';
import { isVisitorRoleTitle } from './guards/visitor-containment.guard';

@Component({
    selector: 'app-auth-callback',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '<div>Authentification en cours...</div>' // Simple message pendant la redirection
})
export class AuthCallbackComponent implements OnInit {
    constructor(
        private oidcSecurityService: OidcSecurityService,
        private router: Router
    ) { }

    ngOnInit(): void {
        // Vérifie l'état d'authentification après le retour du serveur d'authentification
        this.oidcSecurityService.checkAuth()
            .pipe(take(1))
            .subscribe(({ isAuthenticated, userData, errorMessage }) => {
                if (isAuthenticated) {
                    // Récupérer l'URL de retour sauvegardée
                    const returnUrl = sessionStorage.getItem('returnUrl') || '/trucker-feature';
                    sessionStorage.removeItem('returnUrl'); // Nettoyer après usage

                    // Compte kiosque (rôle « Visitor ») : il ne vit que dans /ipad
                    this.router.navigateByUrl(isVisitorRoleTitle(userData?.['matwins_role']) ? '/ipad' : returnUrl);
                } else if (errorMessage) {
                    // Erreur renvoyée par le serveur d'identité (ex. access_denied
                    // quand l'utilisateur clique « Annuler ») : ne pas relancer
                    // authorize() sous peine de boucler sur la page de login.
                    this.router.navigateByUrl('/unauthorized');
                } else {
                    // Si non authentifié, redirige vers la page de login à nouveau
                    this.oidcSecurityService.authorize();
                }
            });
    }
}